import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { requestReportSaleList, requestReportSaleLoad } from "../../Redux/actions";
import Sidebar from './../Sidebar';
import '../../Admin/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//import { DataTable, Header, HeaderRow, HeaderCell, Body, Row, Cell, } from '@table-library/react-table-library/table';
import DataTable from 'react-data-table-component';

function SaleReport(props) {
    const params = useParams();
    const [jobs, setjobs] = useState([]);
    // const [pagination, setpagination] = useState({});
    const navigate = useNavigate();
    const [pages, setpages] = useState([]);
    const [page_size, setpage_size] = useState(10);
    const [change, setchange] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [loaded, setLoaded] = useState(false);
    const [nameOptions, setNameOptions] = useState([]);
    const [taxOptions, setTaxOptions] = useState([]);
    const [invoiceOptions, setInvoiceOptions] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedName, setSelectedName] = useState("ALL");
    const [selectedTax, setSelectedTax] = useState("ALL");
    const [selectedInvoice, setSelectedInvoice] = useState("ALL");
    const [selectedPaymentType, setSelectedPaymentType] = useState("ALL");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [logindetails, setlogindetails] = useState({});
    const [columns, setColumns] = useState([]);
    const totals = {
        grandTotal: 0,
        discount: 0,
        paid: 0,
        balance: 0,
    };

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            props.requestReportSaleLoad({
                data: {
                    token: data1.data.userToken,
                    param1: '611337539322'
                },
            });
        }
    }, []);

    useEffect(() => {
        let jobsData = props.data.saleReportLoadData;
        console.log(jobsData);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                const { names, taxes, bills } = jobsData.data.data;
                console.log(names);
                setNameOptions(JSON.parse(names));
                setTaxOptions(JSON.parse(taxes));
                setInvoiceOptions(JSON.parse(bills));
                props.data.saleReportLoadData = undefined;
            }
        }
    }, [props.data.saleReportLoadData]);

    const handleSearch = (event) => {
        console.log(event.target.value);
        setSearch(event.target.value);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    const nameColumns = [
        { name: 'Invoice No', selector: row => row.invoiceNo },
        { name: 'Invoice Date', selector: row => row.invoiceDate },
        { name: 'Name', selector: row => row.name },
        { name: 'Grand Total', selector: row => row.grandTotal },
        { name: 'Discount', selector: row => row.discount },
        { name: 'Paid', selector: row => row.paid },
        { name: 'Balance', selector: row => row.balance },
        { name: 'Total Qty', selector: row => row.totalQty }
    ];

    const taxColumns = [
        { name: 'Invoice No', selector: row => row.invoiceNo },
        { name: 'Date', selector: row => row.date },
        { name: 'Grand Total', selector: row => row.grandTotal },
        { name: 'Discount', selector: row => row.discount },
        { name: 'Tax', selector: row => row.taxPer },
        { name: 'CGST', selector: row => row.total_cgst },
        { name: 'SGST', selector: row => row.total_sgst },
        { name: 'IGST', selector: row => row.total_igst }
    ];

    const paymentColumns = [
        { name: 'Invoice No', selector: row => row.InvoiceNo },
        { name: 'Name', selector: row => row.Name },
        { name: 'Cash', selector: row => row.Cash },
        { name: 'Card', selector: row => row.CC },
        { name: 'Online', selector: row => row.Online },
        { name: 'Grand Total', selector: row => row.GrandTotal },
    ];

    const HandleViewReport = () => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            let value = "";
            console.log(selectedCategory);
            switch (selectedCategory) {
                case 'Name':
                    value = selectedName;
                    setColumns(nameColumns);
                    break;
                case 'Invoices':
                    value = selectedInvoice;
                    setColumns(nameColumns);
                    break;
                case 'Tax':
                    value = selectedTax;
                    setColumns(taxColumns);
                    break;
                case 'Payment Type':
                    value = selectedPaymentType;
                    setColumns(paymentColumns);
                    break;
                default:
                    value = "";
                    setColumns([]);
            }
            // switch (selectedCategory) {
            //     case 'Name':
            //         console.log(selectedCategory);
            //         columns = nameColumns;
            //         break;
            //     case 'Invoices':
            //         columns = nameColumns;
            //         break;
            //     case 'Tax':
            //         columns = taxColumns;
            //         break;
            //     case 'Payment Type':
            //         columns = paymentColumns;
            //         break;
            //     default:
            //         columns = [];
            // }

            if (fromDate !== "" || toDate !== "") {
                props.requestReportSaleList({
                    //      token: localStorage.getItem('companyToken'),
                    token: '611337539322',
                    page: params.page,
                    page_size: params.page_size,
                    search: 'a',
                    type: selectedCategory,
                    value: value,
                    from: fromDate,
                    to: toDate
                });
            }
            else {
                Swal.fire({
                    title: 'Error',
                    text: "Select from or to date",
                    icon: 'error'
                });
            }
        }
        else {
            navigate('/login');
        }

    }

    function onChangePageSize(e) {
        setpage_size(e.target.value);
        if (e.target.value > 0) {
            navigate(`/rawoutwardlist/1/${e.target.value}`);
        }
    }

    //set job list
    useEffect(() => {
        let jobsData = props.data.saleReportData
        if (jobsData !== undefined) {
            if (jobsData.data) {
                switch (selectedCategory) {
                    case 'Name':
                        setColumns(nameColumns);
                        break;
                    case 'Invoices':
                        setColumns(nameColumns);
                        break;
                    case 'Tax':
                        setColumns(taxColumns);
                        break;
                    case 'Payment Type':
                        setColumns(paymentColumns);
                        break;
                    default:
                        setColumns([]);
                }
                console.log(filter);
                console.log(Array.isArray(filter)); // should be true
                setjobs(jobsData.data.data);
                setFilter(jobsData.data.data);
                // setTotalRows(jobsData.data.meta.total);
                filter.forEach((row) => {
                    totals.grandTotal += row.grandTotal || 0;
                    totals.discount += row.discount || 0;
                    totals.paid += row.paid || 0;
                    totals.balance += row.balance || 0;
                });
            }
        }
    }, [props.data.saleReportData]);

    const handlePageChange = page => {
        props.requestRawOutwardList({
            page: page,
            page_size: page_size,
            search: 'a'
        });
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setpage_size(newPerPage);
        props.requestRawOutwardList({
            page: page,
            page_size: newPerPage,
            search: 'a'
        });
    }

    function printPage() {
        var printContents = "<br/><center><h3>Jobs</h3></center>" + document.getElementById("printme").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    }

    return (
        <>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="col-12 grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="card-body">
                                                        <div class="d-sm-flex justify-content-between align-items-start">
                                                            <div class="btn-wrapper">
                                                                <RWebShare
                                                                    data={{
                                                                        text: "BookkeeperDay - Your Personal Bookkeeping App",
                                                                        url: `${baseUrl}/reportsale/${params.page}/${params.page_size}`,
                                                                        title: "Cart List",
                                                                    }}
                                                                >
                                                                    <p class="btn btn-otline-dark align-items-center"><i class="icon-share"></i> Share</p>
                                                                </RWebShare>
                                                                <button onClick={printPage} class="btn btn-otline-dark"><i class="icon-printer"></i> Print</button>
                                                            </div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-body">
                                                                <div class="row g-3">
                                                                    <div class="col-6 col-md-4">
                                                                        <label for="from" class="form-label">From</label>
                                                                        <input type="date" id="from" name="from" class="form-control"
                                                                            value={fromDate}
                                                                            onChange={(e) => setFromDate(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div class="col-6 col-md-4">
                                                                        <label for="to" class="form-label">To</label>
                                                                        <input type="date" id="to" name="to" class="form-control"
                                                                            value={toDate}
                                                                            onChange={(e) => setToDate(e.target.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row align-items-center g-2">
                                                                    <div className="col-4 col-md-2 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="infoCategory"
                                                                            value="Name"
                                                                            checked={selectedCategory === 'Name'}
                                                                            onChange={(e) => setSelectedCategory(e.target.value)}
                                                                            className="form-check-input me-2"
                                                                            id="radioName"
                                                                        />
                                                                        <label htmlFor="radioName" className="form-check-label mb-0">Name</label>
                                                                    </div>

                                                                    <div className="col-12 col-md-2">
                                                                        <select id="cbName" className="form-select"
                                                                            value={selectedName}
                                                                            onChange={(e) => setSelectedName(e.target.value)}

                                                                        >
                                                                            <option value="ALL">ALL</option>
                                                                            {nameOptions.map((item) => (
                                                                                <option key={item.id} value={item.id}>{item.name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-4 col-md-2 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="infoCategory"
                                                                            value="Invoices"
                                                                            checked={selectedCategory === 'Invoices'}
                                                                            onChange={(e) => setSelectedCategory(e.target.value)}
                                                                            className="form-check-input me-2"
                                                                            id="radioInvoices"
                                                                        />
                                                                        <label htmlFor="radioInvoices" className="form-check-label mb-0">Invoices</label>
                                                                    </div>

                                                                    <div className="col-12 col-md-2">
                                                                        <select
                                                                            id="cbInvoice"
                                                                            className="form-select"
                                                                            value={selectedInvoice}
                                                                            onChange={(e) => setSelectedInvoice(e.target.value)}
                                                                        >
                                                                            <option value="ALL">ALL</option>
                                                                            {invoiceOptions.map((item) => (
                                                                                <option key={item.id} value={item.id}>{item.name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-4 col-md-2 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="infoCategory"
                                                                            value="Tax"
                                                                            checked={selectedCategory === 'Tax'}
                                                                            onChange={(e) => setSelectedCategory(e.target.value)}
                                                                            className="form-check-input me-2"
                                                                            id="radioTax"
                                                                        />
                                                                        <label htmlFor="radioTax" className="form-check-label mb-0">Tax</label>
                                                                    </div>

                                                                    <div className="col-12 col-md-2">
                                                                        <select
                                                                            id="cbTax"
                                                                            className="form-select"
                                                                            value={selectedTax}
                                                                            onChange={(e) => setSelectedTax(e.target.value)}
                                                                        >
                                                                            <option value="ALL">ALL</option>
                                                                            {taxOptions.map((item) => (
                                                                                <option key={item.name} value={item.id}>{item.name}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="row align-items-center g-2">
                                                                    <div className="col-4 col-md-2 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="infoCategory"
                                                                            value="Payment Type"
                                                                            checked={selectedCategory === 'Payment Type'}
                                                                            onChange={(e) => setSelectedCategory(e.target.value)}
                                                                            className="form-check-input me-2"
                                                                            id="radioPaymentType"
                                                                        />
                                                                        <label htmlFor="radioPaymentType" className="form-check-label mb-0">Payment Type</label>
                                                                    </div>

                                                                    <div className="col-12 col-md-2">
                                                                        <select id="cbPaymentType" className="form-select"
                                                                            value={selectedPaymentType}
                                                                            onChange={(e) => setSelectedPaymentType(e.target.value)}
                                                                        >
                                                                            <option>ALL</option>
                                                                            <option>Cash</option>
                                                                            <option>Card</option>
                                                                            <option>UPI</option>
                                                                            <option>Online</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button class="btn btn-primary" style={{ color: '#fff' }} onClick={() => { HandleViewReport(); }}>View</button>
                                                        <div class="table-responsive  mt-1" id="printme">
                                                            {/* {filter.length === 0 ? <p>No data available.</p> : */}
                                                            <DataTable
                                                                columns={columns}
                                                                data={filter}
                                                                pagination
                                                                paginationServer
                                                                paginationTotalRows={totalRows}
                                                                onChangePage={handlePageChange}
                                                                onChangeRowsPerPage={handlePerRowsChange}
                                                                actions={<button className="btn btn-success">Export to PDF</button>}
                                                                subHeader
                                                                subHeaderComponent={
                                                                    <input id="search" type="text" className="w-25 form-control" placeholder="Search..." value={search} onChange={handleSearch} />
                                                                }
                                                                customStyles={tableHeaderStyle}
                                                            // conditionalRowStyles={conditionalRowStyles}
                                                            />
                                                            {/* } */}
                                                        </div>
                                                        {selectedCategory == "Tax" ?
                                                        <div className="row fw-bold">
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total Discount: ₹{totals.discount}
                                                            </div>
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total Grand Amount: ₹{totals.grandTotal}
                                                            </div>
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total CGST: ₹{totals.total_cgst}
                                                            </div>
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total SGST: ₹{totals.total_sgst}
                                                            </div>
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total IGST: ₹{totals.total_igst}
                                                            </div>
                                                        </div> : 
                                                        selectedCategory == "Name" ?
                                                        <div className="row fw-bold">
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total Discount: ₹{totals.discount}
                                                            </div>
                                                            <div className="col-3 col-md-3 d-flex align-items-center">
                                                                Total Grand Amount: ₹{totals.grandTotal}
                                                            </div>
                                                        </div> : ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <Footer /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestReportSaleList, requestReportSaleLoad }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaleReport);